export function getCheckrCandidatePortalUrl(): string {
  return 'https://candidate.checkr.com/login'
}
